(function () {
  function closeMobileMenu(menu, restoreFocus) {
    if (!menu) return;
    menu.removeAttribute('open');
    if (restoreFocus) {
      var summary = menu.querySelector(':scope > summary');
      if (summary) summary.focus();
    }
  }

  function closeOtherDetails(except) {
    document.querySelectorAll('.mf-desktop-nav__group[open], .mf-search[open]').forEach(function (item) {
      if (item !== except) item.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var closeButton = target.closest('[data-mobile-close]');
    if (closeButton) {
      closeMobileMenu(closeButton.closest('[data-mobile-menu]') || document.querySelector('[data-mobile-menu][open]'), true);
      return;
    }

    var mobileLink = target.closest('.mf-mobile-nav a');
    if (mobileLink) {
      closeMobileMenu(mobileLink.closest('[data-mobile-menu]'), false);
      return;
    }

    var summary = target.closest('.mf-desktop-nav__group > summary, .mf-search > summary');
    if (summary) {
      var details = summary.parentElement;
      window.setTimeout(function () { closeOtherDetails(details); }, 0);
      return;
    }

    if (!target.closest('.mf-desktop-nav, .mf-search')) closeOtherDetails(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openMobile = document.querySelector('[data-mobile-menu][open]');
    if (openMobile) {
      closeMobileMenu(openMobile, true);
      return;
    }
    closeOtherDetails(null);
  });

  // Keep native disclosure navigation working when Shopify re-renders a section.
  document.addEventListener('shopify:section:load', function () {
    closeOtherDetails(null);
    updateStickyHeaders();
  });

  function updateStickyHeaders() {
    document.querySelectorAll('.mf-header--sticky').forEach(function (header) {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    });
  }

  window.addEventListener('scroll', updateStickyHeaders, { passive: true });
  updateStickyHeaders();
})();